import { FC } from "react";
import { useTranslation } from "react-i18next";
import MainPageSlider from "./MainPageSlider";
import { PlatformReview } from "../../../domain/models/PlatformReviews";
import { FileOwner } from "../../../domain/enums/FileOwnerEnum";
import ReviewCard from "./ReviewCard";

const ReviewsSection: FC = () => {
    const { t } = useTranslation();

    // TODO :: add only non-deleted users when this logic will be replaced to backend
    const reviews: PlatformReview[] = [
        {
            id: "1",
            title: "Ідеальна платформа для тимчасової роботи з гарантованою оплатою",
            description:
                "Часто підробляю на розвантаженні та переміщенні товарів. Ця платформа ідеальна для тих, хто шукає тимчасову роботу. Я швидко знаходжу вакансії, зідзвонююся із замовником і працюю! Оплата завжди вчасно, дуже зручно!",
            user: {
                firstName: "Антон",
                lastName: "Коломиєць",
                jobTitle: "Логіст",
                profileImage: { ownerType: FileOwner.USER, filePath: "../images/reviews-users-photos/first-user.png" },
            },
            createdAt: "29 вересня 14:18",
        },
        {
            id: "2",
            title: "Швидкий пошук допомоги на будівництві без посередників",
            description:
                "На будівництві часто потрібні додаткові руки для розвантаження матеріалів чи підняття їх на поверхи. Завдяки цьому сайту я можу знайти допомогу швидко і без зайвих формальностей. Контакти напряму, ніяких посередників!",
            user: {
                firstName: "Олег",
                lastName: "Мельник",
                jobTitle: "Будівельник",
                profileImage: { ownerType: FileOwner.USER, filePath: "../images/reviews-users-photos/second-user.png" },
            },
            createdAt: "29 вересня 14:18",
        },
        {
            id: "3",
            title: "Стабільний додатковий заробіток для домашнього майстра",
            description:
                "Часто шукаю додатковий заробіток як домашній майстер. Завдяки сайту завжди знаходжу нових клієнтів для збирання меблів або дрібного ремонту. Все працює чітко — домовляєшся по телефону і працюєш!",
            user: {
                firstName: "Володимир",
                lastName: "Пономарьов",
                jobTitle: "Домашній майстер",
                profileImage: { ownerType: FileOwner.USER, filePath: "../images/reviews-users-photos/third-user.png" },
            },
            createdAt: "29 вересня 14:18",
        },
    ];

    return (
        <div className="relative dmin7:mx-auto flex flex-col justify-center mt-[100px] dmax2:mt-[60px] dmax7:w-[calc(100vw-10px)] dmin7:w-[1910px]">
            <h1 className="H32B dmax2:H24B text-textWhite text-center mb-10 dmax2:mb-6">{t("main.reviewsTitle")}</h1>
            <MainPageSlider
                entities={reviews}
                mapCallback={(review) => (
                    <ReviewCard
                        key={`main-page-slide-${review.id}`}
                        review={review}
                        className="mr-7 di6:mr-5 ti6:mr-4 tmax5:mr-2"
                    />
                )}
            />
        </div>
    );
};

export default ReviewsSection;
